import { Component, OnInit, Input, Inject } from "@angular/core";

import { Observable ,  BehaviorSubject } from "rxjs";

import { GroupService } from "../../../../admin/services/group.service";
import { GroupStub } from "../../../../admin/models/group.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-assign-to-scanning",
    templateUrl: "./side-effect-assign-to-scanning.component.html",
    styleUrls: ["./side-effect-assign-to-scanning.component.scss"],
    standalone: false
})
export class SideEffectAssignToScanningComponent implements OnInit {
    _configuration: any;

    get configuration(): any {
        if (!this._configuration) 
            this._configuration = { timeFrame: 90, group: "-1" };

        return this._configuration;
    }

    set configuration(value: any) {
        this._configuration = value;
    };

    groupsLoading$ = new BehaviorSubject<boolean>(false);
    groupOptions = [];
    organizationOptions = [
        { id: "loggedIn", text: "Logged in Organization" },
        { id: "context", text: "Context Location" }        
    ]

    get applicationNumberContext(): string {
        if (this.configuration.applicationNumberContext === undefined || this.configuration.applicationNumberContext === null) {
            this.configuration.applicationNumberContext = "";
        }
        return this.configuration.applicationNumberContext;
    }

    set applicationNumberContext(value: string) {
        this.configuration.applicationNumberContext = value;
    }

    get assignedGroup(): string {
        return this.configuration.group;
    }

    set assignedGroup(value: string) {
        this.configuration.group = value;
    }

    get organization(): string {
        return this.configuration.organizationSource;
    }

    set organization(value: string) {
        this.configuration.organizationSource = value;
    }

    get organizationContext(): string {
        if (this.configuration.organizationContext === undefined || this.configuration.organizationContext === null) {
            this.configuration.organizationContext = "";
        }
        return this.configuration.organizationContext;
    }

    set organizationContext(value: string) {
        this.configuration.organizationContext = value;
    }

    get timeFrame(): number {
        if (!this.configuration.timeFrame || this.configuration.timeFrame === 0) {
            this.configuration.timeFrame = 90;
        }
        return this.configuration.timeFrame;
    }

    set timeFrame(value: number) {
        this.configuration.timeFrame = value;
    }

    constructor(
        public readonly groupService: GroupService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.configuration = data.configuration;
    }

    ngOnInit() {
        this.groupsLoading$.next(true);
        (this.groupService.get({ stubs: true }) as Observable<GroupStub[]>).subscribe(groups => {
            this.groupOptions = groups.map(g => { return { id: g.id, text: g.displayName }; });
            this.setDefaultGroup();
            this.groupsLoading$.next(false);
        }, error => {
            this.groupsLoading$.next(false);
            console.error(error);
        });
    }

    setDefaultGroup(): void {
        if (!this.groupOptions || this.groupOptions.length === 0)
            return;

        const defaultGroup = this.groupOptions.find(g => g.text.toLowerCase().indexOf("scanning") !== -1);

        if (defaultGroup && this.assignedGroup === "-1") 
            this.assignedGroup = defaultGroup.id;
    }
}
